import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {BaseurlService} from '../../services/baseurl.service';

export interface QwenCommandDto {
  id: number;
  stracliCommandUid: string;
  created: string;
  responseReceived: string | null;
  command: StracliQwenCmd | null;
  response: StracliCmdResponseQwen | null;

  gitlabMrActionType: string | null;
  gitlabMrWebUrl: string | null;

  gitlabMrGitlabStatus: string | null;
  gitlabMrStrapiStatus: string | null;
}

export interface StracliQwenCmd {
  stdin: string;
}

export interface StracliCmdResponseQwen {
  exitCode: number;
  stdout: string;
  stderr: string;
  terminatedOnItsOwn: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class QwenService {
  constructor(
    private http: HttpClient,
    private baseurlService: BaseurlService,
  ) {}

  getQwenCommands(): Observable<QwenCommandDto[]> {
    return this.http.get<QwenCommandDto[]>(`${this.baseurlService.getBaseUrl()}/stracliCommands/qwen`);
  }

  getQwenCommandPerStracliCmdUid(stracliCommandUid: string): Observable<QwenCommandDto> {
    return this.http.get<QwenCommandDto>(`${this.baseurlService.getBaseUrl()}/stracliCommands/qwen/byStracliCmdUid/${stracliCommandUid}`);
  }

  getQwenCommandPerStracliCmdUids(stracliCommandUids: string[]): Observable<QwenCommandDto[]> {
    return this.http.post<QwenCommandDto[]>(`${this.baseurlService.getBaseUrl()}/stracliCommands/qwen/byStracliCmdUid`, stracliCommandUids);
  }

  deleteQwenCommand(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseurlService.getBaseUrl()}/stracliCommands/qwen/${id}`);
  }
}
